import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Edit2, AlertCircle } from 'lucide-react';

const EditRecurringDialog = ({ open, onClose, onEdit, operationName }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="edit-recurring-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold flex items-center gap-2">
            <Edit2 className="h-6 w-6 text-blue-500" />
            Modifier l'opération récurrente
          </DialogTitle>
          <DialogDescription>
            {operationName ? (
              <>
                <strong>{operationName}</strong> fait partie d'une série récurrente.
                <br />
                Que souhaitez-vous modifier ?
              </>
            ) : (
              <>Cette opération fait partie d'une série récurrente. Que souhaitez-vous modifier ?</>
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 mt-4">
          <Button
            onClick={() => onEdit('this_only')}
            variant="outline"
            className="w-full justify-start text-left h-auto py-4 px-4"
            data-testid="edit-this-only"
          >
            <div>
              <div className="font-semibold mb-1">Seulement cette occurrence</div>
              <div className="text-xs text-gray-500">Modifie uniquement cette opération, les autres restent inchangées</div>
            </div>
          </Button>

          <Button
            onClick={() => onEdit('future')}
            variant="outline"
            className="w-full justify-start text-left h-auto py-4 px-4"
            data-testid="edit-future"
          >
            <div>
              <div className="font-semibold mb-1">Cette occurrence et les suivantes</div>
              <div className="text-xs text-gray-500">Modifie cette opération et toutes les futures occurrences</div>
            </div>
          </Button>

          <Button
            onClick={() => onEdit('all')}
            variant="outline"
            className="w-full justify-start text-left h-auto py-4 px-4 border-blue-200 hover:bg-blue-50"
            data-testid="edit-all"
          >
            <div>
              <div className="font-semibold mb-1 text-blue-600">Toute la série</div>
              <div className="text-xs text-gray-500">Modifie toutes les occurrences (passées et futures)</div>
            </div>
          </Button>

          <Button
            onClick={onClose}
            variant="ghost"
            className="w-full"
            data-testid="cancel-edit"
          >
            Annuler
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditRecurringDialog;
